import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {PageState} from './qs-checks-controlling-home.reducer';
import {NotificationService} from '@orga-app/providers/notification.service';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {filter, map, tap, withLatestFrom} from 'rxjs/operators';
import {QsChecksEntityTypes} from '../../../../client-constants';
import PRUEFLAUF_ENTITY = QsChecksEntityTypes.PRUEFLAUF_ENTITY;
import {Prueflauf} from '../../../../clients/qschecks';
import {getPrueferRollenIds, getPruefplanId, getSaisonIdListe} from './qs-checks-controlling-home.selectors';
import {SaisonUebersichtLadenAction} from './qs-checks-controlling-home.actions.ui';

@Injectable()
export class QsChecksControllingHomeEffectsWs {

    @Effect()
    readModelUpdaterPruefplanAktuell$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFLAUF_ENTITY && x.message.entity !== '';
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Prueflauf> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanId)),
            this.store.pipe(select(getSaisonIdListe)),
            this.store.pipe(select(getPrueferRollenIds)))
        , filter(([x, pruefplanId, saisonIdListe, prueferRollenIds]) => {
            return pruefplanId !== null && x.pruefplan_id === pruefplanId
                && saisonIdListe !== null && saisonIdListe.length > 0 && prueferRollenIds !== null && prueferRollenIds.length > 0;
        })
        , map(([x, pruefplanId, saisonIdListe, prueferRollenIds]) => {
            return new SaisonUebersichtLadenAction({
                pruefplanId: pruefplanId,
                saisonIds: saisonIdListe,
                rollenIds: prueferRollenIds
            });
        })
    );

    @Effect()
    readModelUpdaterPruefplanAktuellNachLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PRUEFLAUF_ENTITY && x.message.method === 'DELETE';
        })
        , withLatestFrom(this.store.pipe(select(getPruefplanId)),
            this.store.pipe(select(getSaisonIdListe)),
            this.store.pipe(select(getPrueferRollenIds)))
        , filter(([x, pruefplanId, saisonIdListe, prueferRollenIds]) => {
            return pruefplanId !== null && x.message.entity_id === pruefplanId
                && saisonIdListe !== null && saisonIdListe.length > 0 && prueferRollenIds !== null && prueferRollenIds.length > 0;
        })
        , map(([x, pruefplanId, saisonIdListe, prueferRollenIds]) => {
            return new SaisonUebersichtLadenAction({
                pruefplanId: pruefplanId,
                saisonIds: saisonIdListe,
                rollenIds: prueferRollenIds
            });
        })
    );


    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private notificationService: NotificationService) {
    }
}
